import React, { useState,useRef } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  PageHeader,
  Row,
  Col,
  Card,
  Divider,
  DatePicker,
} from "antd";
import LogisticsSupportQuotation from "../../../components/contracts/LogisticsSupportQuotation";
import LogisticsSupportForm from "../../../components/contracts/LogisticsSupportForm";
import { PrinterOutlined } from "@ant-design/icons";

import { useReactToPrint } from "react-to-print";
import { dateFormat } from "../../../utils/Constants";
import { weekdays } from "moment";

export default function AddLogisticsSupportQuotation() {
  const [to, setto] = useState("2nd party");
  const [AttnTitle, setAttnTitle] = useState("H.R-Director");
  const [Location, setLocation] = useState("Jeddah-Kingdom of Saudi Arabia");
  const [Email, setEmail] = useState("Email");
  const [PreparedByDate, setPreparedByDate] = useState("Date: (DD/MM/YYYY)");
  const [PreparedName, PreparedForName] = useState("Name");
  const [PreparedByName, setPreparedByName] = useState("Name");
  const [Days, setDays] = useState("10rs. 6 ");
  const [Date, setDate] = useState("");
  const [rateofper, setrateofper] = useState("HOUR");
  const [Years, setYears] = useState("one year");
  const [InvoiceDays, setInvoiceDays] = useState("7");
  const [party, setparty] = useState("1st Party or 2nd party");
  const [paymentsettleddays, setpaymentsettleddays] = useState("0");
  const [Extravat, setExtravat] = useState("1st Party or 2nd party.");
  const [Client, setClient] = useState("Client");
  const [SpecilArticle, setSpecilArticle] = useState("SPECIAL ARTICLE");
  const [Regardsname, setRegardsname] = useState("1st Party Name");
  const [Contract, setContract] = useState("Contact Number");
  const [Description, setDescription] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [ContractValidity, setContractValidity] = useState("one month");
  const onFinish = () => {};
  const onFinishFailed = () => {};
  let printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    // onAfterPrint: () => {
    //   Items.remove(invoiceItemdispatch, []);
    //   setCustomField1("");
    //   setCustomField2("");
    //   setCustomField3("");
    //   setCustomField4("");
    //   setCustomField5("");
    //   setCustomField6("");
    //   invoiceForm.resetFields();
    //   setEnablePrinting(false);
    //   setIsSaved(true);
    // },
  });
  return (
    <>
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ margin: "15px 0px" }}>
          <Col span={12}>

          
            <Form.Item
              label="Quotation for "
              name="Enter Valid 2nd Party Mentioned"
              rules={[
                {
                  required: true,
                  message: "Please enter 2nd Party Mentioned",
                },
              ]}
            >
              <Input
              name="2nd Party Mentioned"
                placeholder="2nd Party Name"
                onChange={(e) => setto(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Attention "
              name="Enter Attention"
              rules={[
                {
                  required: true,
                  message: "Please enter Attention",
                },
              ]}
            >
              <Input
              name="Attention"
                placeholder="Enter Attention"
                onChange={(e) => setAttnTitle(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Location "
              name="Enter Location"
              rules={[
                {
                  required: true,
                  message: "Please enter Location",
                },
              ]}
            >
              <Input
              name="Location"
                placeholder="Enter Location"
                onChange={(e) => setLocation(e.target.value)}
              />
            </Form.Item>

            <Form.Item label="Issue Date" name="issueDate">
              <DatePicker
              placeholder="DD/MM/YYYY"
              format={dateFormat}
                onChange={(date, dateString) => {
                  setDate(dateString);
                }}
              />
              {/* <Input type="date"  onChange={(e)=> setIssueDate(e.target.value)}/> */}
            </Form.Item>



            <Form.Item
              label="Working Hours & Days"
              name="NoofDays"
              rules={[{ required: true, message: "Please enter Working Hours & Days" }]}
            >
              <Input
                placeholder="Enter Working Hours & Days"
                onChange={(e) => setDays(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Specil Article"
              name="SpecilArticle"
              rules={[{ required: true, message: "Please enter Specil Article" }]}
            >
              <Input
                placeholder="Enter Specil Article"
                onChange={(e) => setSpecilArticle(e.target.value)}
              />
            </Form.Item>

            {/* <Form.Item
              label="RATE OF PER"
              name="RATE OF PER"
              rules={[{ required: true, message: "Please select RATE OF PER" }]}
            >
            
              <Input
                placeholder="Enter RATE OF PER"
                onChange={(e) => setrateofper(e.target.value)}
              />
           </Form.Item> */}

            <Form.Item
              label="RATE OF PER"
              name="RATE OF PER"
              rules={[{ required: true, message: "Please select RATE OF PER" }]}
            >
              <Select placeholder="Enter RATE OF PER"  onChange={(e) => setrateofper(e)}>
                <Select.Option value="HOUR">HOUR</Select.Option>
                <Select.Option value="MONTH">MONTH</Select.Option>
              </Select>
            </Form.Item>
            
          </Col>

          <Col span={12}>



          


            <Form.Item
              label="F.A.T"
              name="Parties"
              rules={[
                { required: true, message: "Food,Accomm,Transportation" },
              ]}
            >
              <Select placeholder="Select Party"  onChange={(e) => setparty(e)}>
                <Select.Option value={Regardsname}>1st Party</Select.Option>
                <Select.Option value={to}>2nd Party</Select.Option>
              </Select>
            </Form.Item>

            
    
         
            <Form.Item
              label="Contract Duration"
              name="ContractDuration"
              rules={[{ required: true, message: "Please enter Years" }]}
            >
              <Input
                placeholder="Number of Years"
                onChange={(e) => setYears(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Invoice Days"
              name="Invoice Days"
              rules={[
                { required: true, message: "Please enter Invoice Days" },
              ]}
            >
              <Input
                placeholder="Enter Invoice Days"
                onChange={(e) => setInvoiceDays(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Quotation By "
              name="Quotation By"
              rules={[{ required: true, message: "Please enter Quotation By" }]}
            >
              <Input
                placeholder="1st Party Name"
                onChange={(e) => setRegardsname(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Contact No."
              name="Contact No"
              rules={[{ required: true, message: "Please enter Contact No" }]}
            >
              <Input
                placeholder="Enter Contact No"
                onChange={(e) => setContract(e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Contact Email"
              name="Email"
              rules={[{ required: true, message: "Please enter Email" }]}
            >
              <Input
                placeholder="Enter Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>
            
           
           
         
          </Col>
          <Col span={24}>
            <Divider orientation="left">Add Items</Divider>
            <Row>
              <LogisticsSupportForm />
            </Row>
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              Print Document
            </Button>
          </Col>
          <Col span={20} offset={2}>
            <LogisticsSupportQuotation
            ref={printRef}
              to={to}
              AttnTitle={AttnTitle}
              Years={Years}
              Days={Days}
              party={party}
              InvoiceDays={InvoiceDays}
              SpecilArticle={SpecilArticle}
              Contract={Contract}
              Email={Email}
              rateofper={rateofper}
              Date={Date}


              Location={Location}
              
              PreparedByName={PreparedByName}
              PreparedName={PreparedName}
              
              paymentsettleddays={paymentsettleddays}
              Extravat={Extravat}
              ContractValidity={ContractValidity}
              Client={Client}
           
              Regardsname={Regardsname}
              
              Description={Description}
              Quantity={Quantity}
              CompanyName={CompanyName}
              Remarks={Remarks}
              
              

            />
          </Col>
        </Row>
      </Form>
    </>
  );
}
